module.exports = __webpack_public_path__ + "img/ico-msg.a2d2366c.svg";